<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MNHCpN/tc-custom/9781460302781.jpg?1726755951384" alt="This image is the cover for the book To Catch a Thief, Draycott Abbey Romance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To Catch a Thief, Draycott Abbey Romance
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fast-paced action, vivid detail, a touch of the paranormal, and hot lovemaking will please readers of adventure romance.” —<i>Booklist</i></b><br/><br/>Nell MacInnes can spot a forgery from a mile away. After all, she learned from the best—her father is one of the art world’s most notorious thieves. His brutal beating by the very authorities who claim to keep the world safe from harm taught her one more valuable lesson—<i>trust no one</i>.<br/><br/>The last thing rugged navy SEAL Dakota Smith needs on his mission is a tempting woman he doesn’t trust. But a sketch by Leonardo da Vinci has gone missing, and the art conservator’s skill in detecting forgery would be invaluable, if only her ties to the criminal world are as dead as she says they are.<br/><br/>Soon an edgy partnership and white-hot attraction are forged between Nell and Dakota as they race to Draycott Abbey to track down a ruthless criminal with terrorist ties before time runs out—and the da Vinci is lost forever.<br/><br/><b>“Christina Skye weaves an exciting, action-packed romance that once again connects another puzzle piece to the Draycott Abbey mystery. A fabulous read!” —<i>Fresh Fiction</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christina Skye
      </h2>
      
      <p class="authorDescription body article">Christina Skye loves a good adventure. Living in Arizona gives her plenty of room to practice target shooting and to trek off-road on her motorcycle, researching the details for stories rich with &ldquo;snappy dialogue&rdquo; and an unerring ability to keep &ldquo;the narrative energy high and the pacing swift&rdquo; (Publishers Weekly). With over two million books in print, her novels appear regularly on national bestseller lists. Visit her online at www.christinaskye.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ddde862